import withStyles from '@mui/styles/withStyles';
import React from "react";
import iconBlueClose from "../../assets/images/icon_blue_close.svg";
import sendEmailToBoss from "../../assets/images/sendEmailToBoss.png";

const topOffset = "10%";
const button = {
  boxShadow: "0px 3px 20px #00000026",
  fontSize: "16px",
  fontWeight: "bold",
  textTransform: "uppercase",
  padding: "16px 30px",
  color: "#FFFFFF",
  borderRadius: "20px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "80%",
};
const block = {
  padding: "0px 60px 0px 60px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};
const styles = (theme) => ({
  root: {
    background: "white",
    minHeight: "100vh",
  },
  kyteTecRegistration: {
    position: "fixed",
    width: "100vw",
    top: topOffset,
    background: "linear-gradient(#4396e6, #a5d6e7)",
    borderRadius: "15px 15px 0px 0px",
    zIndex: 100,
    boxShadow: "2px 2px 8px grey",
    //maxHeight: "100vh",
    //overflowY: "auto",
  },
  whiteText: {
    color: "white",
    textAlign: "center",
    textTransform: "uppercase",
    fontFamily: "Montserrat",
    fontWeight: "200",
    fontSize: "27px",
    padding: "21px 0px",
  },
  closeIcon: {
    position: "absolute",
    top: 18,
    right: 13,
    filter:
      "invert(100%) sepia(84%) saturate(2%) hue-rotate(149deg) brightness(103%) contrast(101%)",
  },
  block: block,
  buttonDanger: {
    ...button,
    backgroundColor: "#ffab9d",
    border: "none",
    maxHeigth: "40px",
    width: "100%",
  },
  buttonInfo: {
    ...button,
    backgroundColor: "white",
    color: "#4396e6",
  },
});
function KyteTecEmailSuccess({ classes, setShowKyteTecEmailModal }) {
  return (
    <div style={{ position: "relative" }} className={classes.block}>
      <img
        className={classes.closeIcon}
        src={iconBlueClose}
        alt="Close register to kyte tec modal"
        onClick={(e) => setShowKyteTecEmailModal(false)}
      />
      <div style={{ marginTop: "50px" }}>
        <div className={classes.whiteText}>
          <div
            style={{
              fontSize: "25px",
            }}
          >
            <p>Eine E-Mail wurde versendet.</p>
          </div>
          <div style={{ marginBottom: "330px" }}>
            <img src={sendEmailToBoss} alt="send email" />
            <div className={classes.whiteText} style={{ marginTop: "30px" }}>
              <p>Vielen Dank!</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default withStyles(styles)(KyteTecEmailSuccess);
